import { v4 as uuidv4 } from 'uuid';

import { ModuleSlotMap } from '~/modules';
import { ModuleSlotId, ModuleType } from '~/modules/Module.types';

export const modulesConfig: ModuleSlotMap = {
  [ModuleSlotId.MAIN]: [
    {
      id: uuidv4(),
      moduleType: ModuleType.RISK_MANAGED_SUPPLIER_WIDGET,
      grid: { size: { xs: 12, md: 6, xl: 4 } },
    },
    {
      id: uuidv4(),
      moduleType: ModuleType.SUPPLIER_RISK_ALERT_WIDGET,
      grid: { size: { xs: 12, md: 6, xl: 4 } },
    },
    {
      id: uuidv4(),
      moduleType: ModuleType.RISK_COUNTRY_MAP,
      grid: { size: { xs: 12, md: 12, xl: 12 } },
    },
    {
      id: uuidv4(),
      moduleType: ModuleType.RISK_COUNTRY_REPORT_LIST_WIDGET,
      grid: { size: { xs: 12, md: 12, xl: 12 } },
    },
  ],
};
